if (document.querySelector(".products-create") || document.querySelector(".products-edit")) {
    quill = new Quill("#description", {
        modules: {
            toolbar: [
                ['bold', 'italic', 'underline'],
            ],
        },
        theme: "snow",
    });
    quill.on('text-change', function(delta, oldDelta, source) {
        quill.on('text-change', function(delta, oldDelta, source) {
            document.getElementById("descriptionTextarea").value = quill.root.innerHTML;
        });
    });
    quill.root.innerHTML = document.getElementById("descriptionTextarea").value;
    new TomSelect(document.querySelector("#productTags"), {
        maxItems: null,
        plugins: {
            'checkbox_options': {
                'checkedClassNames':   ['ts-checked'],
                'uncheckedClassNames': ['ts-unchecked'],
            }
        },
        allowEmptyOption: true,
    });

    let fetchProductButton = document.getElementById('fetchProductButton');
    if (fetchProductButton) {
        fetchProductButton.addEventListener('click', function (e) {
            const searchProductName = encodeURIComponent(document.getElementById('quickbooks_product_name').value);
            axios.get(`/quickbooks/find-products-by-name/${searchProductName}`)
                .then(response => {
                    let data = response.data;
                    let searchProductsList = document.getElementById('searchProductsList');
                    searchProductsList.innerHTML = '';
                    document.getElementById('searchProductsDetails').style.display = 'block';

                    if (Array.isArray(data) && data.length > 0) {
                        data.forEach((product, index) => {
                            let row = document.createElement('div');
                            row.innerHTML = `
                                <span>${index + 1}. </span>
                                <span>${product.name}, </span>
                                <button type="button" class="btn btn-primary btn-mc select-product-btn" data-id="${product.qb_id}">Select</button>
                            `;
                            searchProductsList.appendChild(row);
                        });

                        document.querySelectorAll('.select-product-btn').forEach(button => {
                            button.addEventListener('click', () => {
                                document.getElementById('external_id').value = button.getAttribute('data-id');
                            });
                        });
                    } else {
                        document.getElementById('searchProductsDetails').style.display = 'block';
                        let searchProductsList = document.getElementById('searchProductsList');
                        searchProductsList.innerHTML = '';
                        let row = document.createElement('div');
                        row.innerHTML = `<span>No products found</span>`;
                        searchProductsList.appendChild(row);
                    }
                })
                .catch(error => {
                    console.log('Error fetching product:', error);
                    document.getElementById('searchProductsDetails').style.display = 'block';
                    let searchProductsList = document.getElementById('searchProductsList');
                    searchProductsList.innerHTML = '';
                    let row = document.createElement('div');
                    row.innerHTML = `<span>No products found</span>`;
                    searchProductsList.appendChild(row);
                });
        });
    }

    document.querySelectorAll('.select-product-btn').forEach(button => {
        button.addEventListener('click', () => {
            document.getElementById('external_id').value = button.getAttribute('data-id');
        });
    });
}
